const CheckoutFeature = () => import(/* webpackChunkName: "dist/js/features-checkout" */ './CheckoutFeature.vue');
const CheckoutPage = () => import(/* webpackChunkName: "dist/js/features-checkout" */ '@resources/scripts/features/checkout/CheckoutPage.vue');
const OrderConfirmedPage = () => import(
/* webpackChunkName: "dist/js/features-checkout" */ '@resources/scripts/features/checkout/OrderConfirmationPage.vue');
const routes = [
    {
        path: '/:studioSlug/checkout',
        component: CheckoutFeature,
        children: [
            {
                path: 'home',
                alias: '/:studioSlug/checkout',
                meta: { title: 'Checkout' },
                component: CheckoutPage,
            },
        ],
    },
    {
        path: '/:studioSlug/order-confirmed/:orderId',
        component: OrderConfirmedPage,
        meta: { title: 'Order Confirmed' },
    },
];
export default routes;
